import React from 'react';
import ENSAvatar from './ENSAvatar';
import Badge from './Badge';

export default function UserModal({ user, onClose }) {
  if (!user) return null;
  // Show Level 12 (All Unlocked) for special addresses with all levels
  const showAllLevels = user.isSpecial && (user.hasAllLevels || user.highestLevel === 12);
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
      <div className="bg-white dark:bg-gray-900 rounded-2xl shadow-2xl p-6 w-full max-w-xs relative">
        <button onClick={onClose} className="absolute top-2 right-2 text-gray-400 hover:text-pink-500 text-xl font-bold">×</button>
        <div className="flex flex-col items-center gap-2">
          <ENSAvatar address={user.address} size={56} />
          <div className="font-mono text-cyan-700 dark:text-cyan-300 text-sm break-all">{user.address}</div>
          <div className="flex flex-wrap gap-1 mt-1">
            {user.isSpecial && <Badge label="Special" color="#f472b6" />}
            {user.isTopReferrer && <Badge label="Top Referrer" color="#38bdf8" />}
            {showAllLevels
              ? <Badge label="Level 12 (All Unlocked)" color="#a7f3d0" />
              : user.level && <Badge label={`Level ${user.level}`} color="#a7f3d0" />}
          </div>
          {user.inviteCode && <div className="text-xs text-gray-500 mt-2">Invite Code: <span className="font-mono text-cyan-500">{user.inviteCode}</span></div>}
          {user.joinDate && <div className="text-xs text-gray-400">Joined: {user.joinDate}</div>}
          {user.earnings && <div className="text-xs text-emerald-500">Total Earned: {user.earnings} USDT</div>}
        </div>
      </div>
    </div>
  );
}
